module.exports = __webpack_public_path__ + "img/qrcode.44e0d7c1.png";